module.exports = __webpack_public_path__ + "img/resized-APP-0010-1.b8d6bebf.png";